import DisbursementInvoiceList from './DisbursementInvoiceList.vue';

export default DisbursementInvoiceList;